module.exports = __webpack_public_path__ + "img/paypal.fd69550.svg";